import React, { memo } from "react";
import { Box, Typography, Skeleton } from "@mui/material";
import { C } from "../theme";
import { TECHNICIAN_STATUS } from "../constants";

const KPI = memo(function KPI({ label, value, accent }) {
  return (
    <Box
      sx={{
        px: 1.5,
        py: 0.75,
        border: `1px solid ${C.border}`,
        borderRadius: 1.5,
        bgcolor: "#fff",
        flex: "1 1 0",
        minWidth: 0,
        borderTop: `3px solid ${accent || C.border}`,
      }}
    >
      <Typography sx={{ fontSize: 10, fontWeight: 700, color: C.textSoft, textTransform: "uppercase" }}>
        {label}
      </Typography>
      <Typography sx={{ fontSize: 18, fontWeight: 700, color: C.text, lineHeight: 1.1 }}>
        {value}
      </Typography>
    </Box>
  );
});

export default function HRGlobalKPIs({ technicians = [], loading = false }) {
  const total = technicians.length;
  const active = technicians.filter((t) => t.status === TECHNICIAN_STATUS.ACTIVE).length;
  const onLeave = technicians.filter((t) => t.status === TECHNICIAN_STATUS.ON_LEAVE).length;

  const withScores = technicians.filter(
    (t) => (t.attitudeScore ?? 0) > 0 || (t.adminComplianceScore ?? 0) > 0
  );
  const avgScore =
    withScores.length > 0
      ? Math.round(
          withScores.reduce(
            (s, t) =>
              s + ((t.attitudeScore ?? 0) + (t.adminComplianceScore ?? 0)) / 2,
            0
          ) / withScores.length
        )
      : "—";

  if (loading) {
    return (
      <Box sx={{ display: "flex", gap: 1, flexShrink: 0 }}>
        {[1, 2, 3, 4].map((i) => (
          <Skeleton key={i} variant="rounded" sx={{ flex: 1, height: 52 }} />
        ))}
      </Box>
    );
  }

  return (
    <Box sx={{ display: "flex", gap: 1, flexShrink: 0 }}>
      <KPI label="Equipo" value={total} accent={C.primary} />
      <KPI label="Activos" value={active} accent={C.success} />
      <KPI label="Permiso" value={onLeave} accent={C.warning} />
      <KPI label="Prom. eval." value={avgScore} accent="#6366f1" />
    </Box>
  );
}
